import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import "./index.css";
import App from "./App";
import { store } from "./store";
import reportWebVitals from "./reportWebVitals";

import { CssBaseline } from "@mui/material";
import { ColorModeProvider } from "./contexts/ColorModeContext";
import ThemeWithMode from "./ThemeWithMode";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ColorModeProvider>
        <ThemeWithMode>
          <CssBaseline />
          <App />
        </ThemeWithMode>
      </ColorModeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
